import styled from 'styled-components'

export const BlogCategoriesListContainer = styled.div`
  margin-top: 78px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  padding: 44px 29px 20px;
`

export const BlogCategoriesListTitle = styled.h2`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #000000;
  margin-top: 0;
  margin-bottom: 24px;
`

export const BlogCategoriesUl = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const BlogCategoriesItem = styled.li`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.01em;
  margin-bottom: 18px;
  text-transform: uppercase;
  padding: 0;
`

export const BlogCategoryLink = styled.a`
  color: #000000;
  text-decoration: none;
`
